import { IChannelListFilterSelection } from 'pages/Conversations/interfaces/IChannelListFilterSelection';
import { ChannelFilterSelectionFragment, FilterSelectionType } from 'shared/types/graphql';
import { ChannelListFilterDraft, defaultChannelListFilterDraft } from './ChannelListFilterDraft';

export type ChannelListFilterSelectionDraft = Omit<IChannelListFilterSelection, 'filters'> & {
  filters: ChannelListFilterDraft;
};

export const defaultChannelFilterSelectionDraft: ChannelFilterSelectionFragment = {
  id: '',
  name: '',
  isDeleted: false,
  userChannelFilterSelections: [],
  filterSelectionType: FilterSelectionType.PublicReadonly,
  filters: defaultChannelListFilterDraft,
};
